import { useMediaQuery } from "@/hooks/use-media-query";
import Header from "modules/main/components/header";
import { ProductSheet } from "modules/product/components/product-sheet";
import { useParams } from "react-router-dom";
import { isDesktopSize } from "utils/is-desktop";

export const ProductPage = () => {        
    const pathParams =  useParams();
    const isDesktop = useMediaQuery(isDesktopSize)

    return (
        <>
        <div className="flex w-full m-auto">
            <ProductSheet 
                productID={pathParams.p??""}
                isMobile={!isDesktop}
            />
        </div>
        </>
    );
}

